import React from 'react';
import classNames from 'classnames';

import * as styles from './QuoteWithPhoto.module.scss';
import { colors } from '@styles/core-styles/theme';
import { QuoteWithPhotoProps } from './QuoteWithPhotoProps';

export const QuoteWithPhoto: React.FC<QuoteWithPhotoProps> = ({
	className,
	image,
	author,
	background = colors.white,
	photoOnLeft = false,
	flipImage = false,
	spacing = 'none',
	children,
	containerStyles,
}) => {
	return (
		<section
			className={classNames(
				styles.quoteWithPhotoContainer,
				photoOnLeft && styles.photoOnLeft,
				className
			)}
		>
			<div className={styles.wrapper}>
				<div
					className={classNames(
						styles.textContainer,
						spacing === 'between' &&
							'd-flex justify-content-between flex-column'
					)}
					style={{ background, ...containerStyles }}
				>
					<div className={classNames(styles.quote)}>{children}</div>
					<div
						className={classNames(
							styles.employeePosition,
							'uppercase font-600'
						)}
					>
						{author}
					</div>
				</div>
				<div
					className={classNames(
						styles.image,
						flipImage && styles.flipped,
						'd-flex flex-column'
					)}
				>
					<img src={image} alt={author} />
				</div>
			</div>
		</section>
	);
};
